// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 7.5% 10px 7.5%;
  background-color: white;
  color: black;
  margin-bottom: 50px;
  width: 85%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  position: fixed;
  /* Default to fixed */
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
}

#forflex {
  width: 75%;
  display: flex;
  justify-content: space-between;
}

.logo {
  font-size: 24px;
  margin-top: 10px;
  cursor: pointer;
}

.hamburger {
  display: none;
  position: relative;
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 25px;
}

.dropdown-tabs > a > img {
  width: 60px;
  margin-right: 15px;
}

.dropdown-tabs > a > div > h1 {
  font-size: 18px;
}

.dropdown-tabs > a > div > p {
  font-size: 15px;
  color: #6d6d6d;
}

.hamburger::before,
.hamburger::after,
.hamburger div {
  content: "";
  position: absolute;
  width: 150%;
  height: 20px;
  left: 0;
  transition: all 0.3s;
}

.hamburger::before {
  top: 0;
}

.hamburger div {
  top: 50%;
  transform: translateY(-50%);
}

.hamburger::after {
  bottom: 0;
}

.tabs {
  display: flex;
  align-items: center;
}

.tabs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 20px;
  /* Add gap between each tab */
}

.tabs ul li {
  margin-right: 20px;
}

.tabs ul li a {
  font-size: 20px;
  color: black;
  text-decoration: none;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-weight: normal;
  background-color: #f8f8fa;
  /* box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; */
}

.dropdown {
  position: relative;
  background-color: #f8f9fa;
}

.dropdown-content {
  top: 47px;
  position: absolute;
  background-color: #ffffff;
  min-width: 400px;
  display: none;
  color: black;
  z-index: 200000000;
}

.dropdown-content.show {
  display: block;
  background-color: #ffffff;
  z-index: 2;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  border-radius: 10px;
  /* box-shadow: inset rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; */
}

.dropdown-content.show > hr {
  width: 90%;
  color: #aaa5a5;
  margin-top: -10px;
}

.contact button {
  background-color: #20303f;
  color: white;
  border: none;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 0;
  cursor: pointer;
  border-radius: 5px;
}

/* Media Query for Mobile Screens */
@media (max-width: 1024px) {
  .navbar {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 2% 3%;
    position: static;
    /* Change to static for mobile */
    width: 94%;
    /* Make it full width on mobile */
    transform: none;
    /* Remove the transform property */
    left: 0;
    /* Reset left position */
  }

  .hamburger {
    display: block;
    height: 20px;
  }

  .dropdown-tabs > a > div > h1 {
    font-size: 16px;
  }

  .dropdown-tabs > a > div > p {
    font-size: 15px;
    color: #6d6d6d;
    width: 70%;
  }

  .dropdown-tabs > a > div > p {
    font-size: 14px;
    color: #6d6d6d;
  }

  .dropdown-tabs > a > img {
    width: 40px;
    margin-right: 15px;
  }

  .tabs {
    position: fixed;
    top: 0;
    right: -100%;
    height: 100%;
    width: 50%;
    background-color: #f8f9fa;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    overflow-y: auto;
    transition: right 0.3s ease-in-out;
    z-index: 1000;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
  }

  .tabs.show {
    right: 0;
  }

  .tabs ul {
    flex-direction: column;
    width: 100%;
  }

  .tabs ul li {
    width: 100%;
    margin: 0;
  }

  .tabs ul li a,
  .contact button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 10px 15px;
    display: flex;
  }

  .dropdown-content {
    position: relative;
    top: 0px;
    /* left: -15px; */
  }

  .contact {
    width: 100%;
  }

  .contact button {
    background-color: #20303f;
    width: 80%;
    color: white;
    border: none;
    padding: 15px;
    margin: 20px;
    margin-right: 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    cursor: pointer;
    border-radius: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,4CAA4C;EAC5C,eAAe;EACf,qBAAqB;EACrB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,6FAA6F;AAC/F;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV;0CACwC;EACxC,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,UAAU;IACV,iCAAiC;IACjC,eAAe;IACf,kCAAkC;IAClC,OAAO;IACP,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["/* Base Styles */\r\n.navbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 13px 7.5% 10px 7.5%;\r\n  background-color: white;\r\n  color: black;\r\n  margin-bottom: 50px;\r\n  width: 85%;\r\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\r\n  position: fixed;\r\n  /* Default to fixed */\r\n  top: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 2000;\r\n}\r\n\r\n#forflex {\r\n  width: 75%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.logo {\r\n  font-size: 24px;\r\n  margin-top: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.hamburger {\r\n  display: none;\r\n  position: relative;\r\n  width: 30px;\r\n  height: 30px;\r\n  cursor: pointer;\r\n  font-size: 25px;\r\n}\r\n\r\n.dropdown-tabs > a > img {\r\n  width: 60px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.dropdown-tabs > a > div > h1 {\r\n  font-size: 18px;\r\n}\r\n\r\n.dropdown-tabs > a > div > p {\r\n  font-size: 15px;\r\n  color: #6d6d6d;\r\n}\r\n\r\n.hamburger::before,\r\n.hamburger::after,\r\n.hamburger div {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 150%;\r\n  height: 20px;\r\n  left: 0;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.hamburger::before {\r\n  top: 0;\r\n}\r\n\r\n.hamburger div {\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.hamburger::after {\r\n  bottom: 0;\r\n}\r\n\r\n.tabs {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.tabs ul {\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  gap: 20px;\r\n  /* Add gap between each tab */\r\n}\r\n\r\n.tabs ul li {\r\n  margin-right: 20px;\r\n}\r\n\r\n.tabs ul li a {\r\n  font-size: 20px;\r\n  color: black;\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.dropdown-content a {\r\n  color: black;\r\n  padding: 12px 16px;\r\n  text-decoration: none;\r\n  display: block;\r\n  font-weight: normal;\r\n  background-color: #f8f8fa;\r\n  /* box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; */\r\n}\r\n\r\n.dropdown {\r\n  position: relative;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.dropdown-content {\r\n  top: 47px;\r\n  position: absolute;\r\n  background-color: #ffffff;\r\n  min-width: 400px;\r\n  display: none;\r\n  color: black;\r\n  z-index: 200000000;\r\n}\r\n\r\n.dropdown-content.show {\r\n  display: block;\r\n  background-color: #ffffff;\r\n  z-index: 2;\r\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\r\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\r\n  border-radius: 10px;\r\n  /* box-shadow: inset rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; */\r\n}\r\n\r\n.dropdown-content.show > hr {\r\n  width: 90%;\r\n  color: #aaa5a5;\r\n  margin-top: -10px;\r\n}\r\n\r\n.contact button {\r\n  background-color: #20303f;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  margin: 0;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* Media Query for Mobile Screens */\r\n@media (max-width: 1024px) {\r\n  .navbar {\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 2% 3%;\r\n    position: static;\r\n    /* Change to static for mobile */\r\n    width: 94%;\r\n    /* Make it full width on mobile */\r\n    transform: none;\r\n    /* Remove the transform property */\r\n    left: 0;\r\n    /* Reset left position */\r\n  }\r\n\r\n  .hamburger {\r\n    display: block;\r\n    height: 20px;\r\n  }\r\n\r\n  .dropdown-tabs > a > div > h1 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dropdown-tabs > a > div > p {\r\n    font-size: 15px;\r\n    color: #6d6d6d;\r\n    width: 70%;\r\n  }\r\n\r\n  .dropdown-tabs > a > div > p {\r\n    font-size: 14px;\r\n    color: #6d6d6d;\r\n  }\r\n\r\n  .dropdown-tabs > a > img {\r\n    width: 40px;\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .tabs {\r\n    position: fixed;\r\n    top: 0;\r\n    right: -100%;\r\n    height: 100%;\r\n    width: 50%;\r\n    background-color: #f8f9fa;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    overflow-y: auto;\r\n    transition: right 0.3s ease-in-out;\r\n    z-index: 1000;\r\n    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);\r\n  }\r\n\r\n  .tabs.show {\r\n    right: 0;\r\n  }\r\n\r\n  .tabs ul {\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .tabs ul li {\r\n    width: 100%;\r\n    margin: 0;\r\n  }\r\n\r\n  .tabs ul li a,\r\n  .contact button {\r\n    display: block;\r\n    width: 100%;\r\n    text-align: left;\r\n    padding: 10px 15px;\r\n    display: flex;\r\n  }\r\n\r\n  .dropdown-content {\r\n    position: relative;\r\n    top: 0px;\r\n    /* left: -15px; */\r\n  }\r\n\r\n  .contact {\r\n    width: 100%;\r\n  }\r\n\r\n  .contact button {\r\n    background-color: #20303f;\r\n    width: 80%;\r\n    color: white;\r\n    border: none;\r\n    padding: 15px;\r\n    margin: 20px;\r\n    margin-right: 20px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
